import { LocalDate } from '../../../core/model/local-date';
import { Money } from '../../../core/model/money';

export class CooperativeHousingShareTransaction {
  constructor(data?: any) {
    if (data) {
      this.transferDate = LocalDate.fromDate(data.transferDate);
      this.contactId = data.contactId;
      this.name = data.name;
      this.share = data.share;
      this.resultingShare = data.resultingShare;
      this.transferId = data.transferId;
      this.transferType = data.transferType;
    }
  }
  transferDate: LocalDate;
  contactId: string;
  transferId: string;
  name: string;
  share: number;
  resultingShare: number;
  transferType: string;
}
